import * as types from './actionTypes';
import gigService from '../services/gigService';
import { fetch, addTask } from 'domain-task';

function dispatchStatusUpdate(dispatch, type, status) {
    let loadingStatus = {status: status};
    dispatch({ type, loadingStatus });
}

function dispatchBrowseStatusUpdate(dispatch, type, page, status) {
    let loadingStatus = { page, status };
    dispatch({ type, loadingStatus });
}

export function getGig(id) {
    return (dispatch, getState) => {
        const gig = getState().gigs.gig;
        if(gig == null || gig.ID != id ) {
            dispatchStatusUpdate(dispatch, types.GET_GIG_STATUS, 'LOADING');
            let fetchTask = gigService.getGig(id)
                .then(gig => {
                    if(gig) {
                        dispatch({ type: types.GET_GIG, gig });
                        dispatchStatusUpdate(dispatch, types.GET_GIG_STATUS, 'LOADED');
                    }
                    return gig;
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_GIG_STATUS, 'FAILED');
                });
            addTask(fetchTask);
        }
    };
}

export function updateDates(startDate, endDate) {
    const dates = {startDate, endDate};
    return { type: types.SET_GIG_BROWSE_DATES, dates };
}

export function setBrowseTab(selectedTab) {
    return { type: types.SET_GIG_BROWSE_TAB, selectedTab };
}

export function setKeyword(keyword) {
    return { type: types.SET_GIG_KEYWORD, keyword };
}

export function clearSearchString(keyword) {
    return { type: types.CLEAR_GIG_KEYWORD };
}

export function setSearchError(error) {
    return { type: types.SET_GIG_SEARCH_ERROR, error: new Error(error) };
}

export function clearSearchError(error) {
    return { type: types.CLEAR_GIG_SEARCH_ERROR };
}

export function clearBrowseError(error) {
    return { type: types.CLEAR_GIG_BROWSE_ERROR };
}

export function updateSort(sortField) {
    return { type: types.SET_GIG_BROWSE_SORT, sortField };
}

export function updateDistance(distance) {
    return { type: types.SET_GIG_BROWSE_DISTANCE, distance };
}

export function updateDistanceUnit(unit) {
    return { type: types.SET_GIG_BROWSE_DISTANCE_UNIT, unit };
}

export function updateLocation(location) {
    return { type: types.SET_GIG_BROWSE_LOCATION, location };
}

export function addBrowseGenre(genre) {
    return { type: types.SET_GIG_BROWSE_ADD_GENRE, genre };
}

export function removeBrowseGenre(genre) {
    return { type: types.SET_GIG_BROWSE_REMOVE_GENRE, genre };
}

export function browseGigs(page = 1) {
    return (dispatch, getState) => {
        const state = getState();
        const requestingNextPage = page > state.gigs.browse.results.lastPage;
        const selectedTab = state.gigs.browse.selectedTab;
        const currentResults = state.gigs.browse.results;
        const searchCriteria = state.gigs.browse.searchCriteria;
        const searchChanged = selectedTab != currentResults.selectedTab || state.gigs.browse.keyword != currentResults.keyword || JSON.stringify(searchCriteria) != JSON.stringify(currentResults.searchCriteria);
        if(searchChanged || requestingNextPage) {
            if(!requestingNextPage) {
                dispatch(clearGigs());
            }
            dispatchBrowseStatusUpdate(dispatch, types.BROWSE_GIG_STATUS, page, 'LOADING');
            let keyword;
            let sort;
            let distance;
            let distanceUnit;
            let latitude = null;
            let longitude = null;
            let startDate = null;
            let endDate = null;
            let genres;
            if (selectedTab == 'browse') {                
                genres = searchCriteria.selectedGenres;
                sort = searchCriteria.sort;
                distance = searchCriteria.distance;                
                distanceUnit = searchCriteria.distanceUnit;
                startDate = searchCriteria.startDate ? searchCriteria.startDate.format('YYYY-MM-DD') : null;
                endDate = searchCriteria.endDate ? searchCriteria.endDate.format('YYYY-MM-DD') : null;
                if(searchCriteria.location.length) {
                    latitude = searchCriteria.location[0].latitude;
                    longitude = searchCriteria.location[0].longitude;
                }
            }
            else {
                keyword = state.gigs.browse.keyword;
            }
            console.log('fetching gigs');
            let fetchTask = gigService.browseGigs(keyword, genres, distance, distanceUnit, latitude, longitude, startDate, endDate, sort, page)
                .then(data => {
                    if(data) {
                        const results = {
                            lastPage: data.CurrentPage,
                            haveNextPage: data.CurrentPage < data.TotalPages,
                            items: data.Items,
                            selectedTab: selectedTab,
                            searchCriteria: state.gigs.browse.searchCriteria,
                            keyword: state.gigs.browse.keyword
                        };
                        dispatch({ type: types.SET_GIG_BROWSE_RESULTS, results });
                        dispatchBrowseStatusUpdate(dispatch, types.BROWSE_GIG_STATUS, page, 'LOADED');
                    }
                    return data;
                })
                .catch(error => {
                    dispatchBrowseStatusUpdate(dispatch, types.BROWSE_GIG_STATUS, page, 'FAILED');
                    dispatch({ type: types.SET_GIG_BROWSE_ERROR, error});
                    return Promise.reject(error);
                });
            addTask(fetchTask);
        }
    };
}

export function clearGigs() {
    return { type: types.CLEAR_GIG_BROWSE_RESULTS };
}

export function clearSearchCriteria() {
    return { type: types.CLEAR_GIG_SEARCH_CRITERIA };
}